export default __webpack_public_path__ + "static/media/blogimage.91c73721.png";